import http from "services/http";

const PRE_ENDPOINT = "/api/method/freshdi.api.web.v3";

export const apiGetInquirys = (data?: any) =>
  http.post(`${PRE_ENDPOINT}.inquiry.get_customer_inquiries`, data);

export const apiGenerateInquiry = (topic?: string) =>
  http.get(`${PRE_ENDPOINT}.inquiry.generate_inquiry`, { params: { topic } });

export const apiGetInquiries = (data?: any) =>
  http.get(`${PRE_ENDPOINT}.inquiry.get_inquired_customers`, {
    params: data,
  });

// From biz
export const apiGetFarmInquiries = (data?: any) =>
  http.get(`${PRE_ENDPOINT}.inquiry.get_farm_inquiries`, { params: data });


export const apiMarkInquirySeen = (id: string) =>
  http.put(`${PRE_ENDPOINT}.inquiry.mark_as_seen`, { inquiry_id: id });

export const apiGetInquiryDetail = (inquiry_id: string) =>
  http.get(`${PRE_ENDPOINT}.inquiry.get_farm_inquiry_details`, {
    params: { inquiry_id },
  });
